<template>
  <el-table
    class="add-table"
    max-height="300"
    :data="dataList"
    style="width: 100%"
    row-key="type"
  >
    <el-table-column
      align="center"
      label="收款项"
      width="100"
      prop="typeName"
    />
    <el-table-column align="center">
      <template slot="header"> 收款方式 </template>
      <template slot-scope="scope">
        <span>{{ getPayMethods(scope.row.payMethod) }}</span>
      </template>
    </el-table-column>
    <el-table-column align="center">
      <template slot="header">收款金额</template>
      <template slot-scope="scope">
        {{ scope.row.payAmount | addUnit(scope.row) }}
      </template>
    </el-table-column>
    <el-table-column
      align="”center”"
      label="发车前收款"
      width="”100”"
      prop="”advancePayment”"
    >
      <template slot-scope="scope">
        <span>{{ getAdvancePayment(scope.row.advancePayment) }}</span>
      </template>
    </el-table-column>
    <el-table-column
      align="center"
      label="收款金额保留位数"
      width="200"
      prop="amountAccuracy"
    >
      <template slot-scope="scope">
        <span>{{ amountAccuracyFormate(scope.row.amountAccuracy) }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { mapState } from 'vuex'
import { isNewOverdue } from '@/pages/utils/overdue'

export default {
  name: 'OtherCollectionItemsDetailNew',
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  filters: {
    addUnit(val, rowData) {
      if (isNewOverdue(rowData)) {
        return `未付租金*${rowData.lateFeeProportion}%/日`
      } else if (val === 0 || val) {
        return val
      } else {
        return '--'
      }
    },
  },
  computed: {
    ...mapState({
      paymentMethods: (state) => state.global.paymentMethods,
      advancePaymentList: (state) => state.global.advancePaymentList,
    }),
  },
  data() {
    return {}
  },

  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' })
    this.$store.dispatch('getPaymentMethods', { type: 'payMode' })
    this.$store.dispatch('getPaymentMethods', { type: 'advancePayment' })
  },
  methods: {
    // 获取付款方式
    getPayMethods(type) {
      const payModeItem = this.paymentMethods.find(
        (item) => Number(item.code) === Number(type),
      )
      return payModeItem ? payModeItem.name : '--'
    },
    // 发车前收款
    getAdvancePayment(val) {
      const advancePayment = this.advancePaymentList.find(
        (item) => Number(item.code) === Number(val),
      )
      return advancePayment ? advancePayment.name : '--'
    },

    // 收款金额保留位数
    amountAccuracyFormate(val) {
      if (val !== null) {
        if (Number(val) === 0) {
          return '金额取整'
        } else if (Number(val) === 2) {
          return '金额保留两位小数'
        } else {
          return '--'
        }
      } else {
        return '--'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.add-table {
  margin-bottom: 20px;
  ::v-deep thead tr {
    background-color: #f7f8fa;
  }
}
#app .add-table ::v-deep thead tr th {
  border: none !important;
}
.ladder-box {
  .ladder-item {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }
}
</style>
